import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

interface Me {
  user: { id: string; email: string; name: string | null; locale: string; emailVerified: boolean; lastSignInAt: string | null }
  tenantId: string
  role: string
}

export function ProfilePage() {
  const t = useT()
  const me = useQuery({ queryKey: ['auth-me'], queryFn: () => apiClient.get<Me>('/auth/me') })

  if (me.isLoading) return <p>{t('common.loading')}</p>
  if (me.isError || !me.data) return <p>{t('common.error')}</p>

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">{t('settings.profile.title')}</h1>
      <dl className="grid grid-cols-[140px_1fr] gap-y-3 gap-x-6 text-sm">
        <dt className="opacity-70">{t('auth.email')}</dt>
        <dd>{me.data.user.email} {me.data.user.emailVerified && <span className="text-xs opacity-70">({t('settings.profile.verified')})</span>}</dd>

        <dt className="opacity-70">{t('settings.profile.name')}</dt>
        <dd>{me.data.user.name ?? '—'}</dd>

        <dt className="opacity-70">{t('settings.profile.role')}</dt>
        <dd>{me.data.role}</dd>

        <dt className="opacity-70">{t('settings.profile.locale')}</dt>
        <dd>{me.data.user.locale}</dd>

        <dt className="opacity-70">{t('settings.profile.lastsignin')}</dt>
        <dd>{me.data.user.lastSignInAt ? new Date(me.data.user.lastSignInAt).toLocaleString() : '—'}</dd>
      </dl>
    </div>
  )
}
